<main>
    @if (!isHealthRoute) {
        <site-header [tokenExpirySeconds]="tokenExpirySeconds"/>
    }

    <div class="outlet">
        <router-outlet></router-outlet>
    </div>

    @if (!isHealthRoute) {
        <site-footer />
        <loading-overlay></loading-overlay>
    }
</main>